export default __webpack_public_path__ + "static/media/history@2x.f95d0384.png";